import React from 'react';
import { styled } from 'styled-components';
import { Colors } from '../../../../play-core/styles/Colors';
import { mediaQueries } from '../../../../play-core/styles/Viewports';
import { PlayLink } from '../ClickableComponents/PlayLink';
import { colorSets } from '../ClickableComponents/styles';
import { jsx as _jsx } from "react/jsx-runtime";
export const Breadcrumb = ({
  title,
  link,
  onClick
}) => /*#__PURE__*/_jsx(StyledLink, {
  text: title,
  colorSet: {
    color: colorSets.transparent.color,
    backgroundColor: 'transparent',
    hoverBackgroundColor: 'transparent',
    activeBackgroundColor: 'transparent'
  },
  to: link,
  fontType: 'Medium',
  isInternal: true,
  onClick: onClick
});
const StyledLink = styled(PlayLink).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "Breadcrumb__StyledLink",
  componentId: "sc-1gowevl-0"
})(["border-radius:2px;width:fit-content;height:28px;min-height:28px;padding:0;padding-left:8px;margin-right:8px;transition:all 200ms ease-in-out;&:hover{color:", ";}font-size:12px;@media ", "{font-size:14px;}"], Colors.WHITE, mediaQueries.mediumUp);